import React from "react";
import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";
import { DEFAULT_DASHBOARD_URL } from "../../../utils/constants";
import { IRedirectButtonProps } from "./DashboardRedirectButtonTypes";

export default function DashboardRedirectButton(props: IRedirectButtonProps) {
  const handleRedirect = () => {
    if (props.dashboardId && props.uuid) {
      const url = `${DEFAULT_DASHBOARD_URL}dashboardId=${props.dashboardId}&tabUUID=${props.uuid}`;
      window.open(url, "_self");
    } else if (props.dashboardId && !props.uuid) {
      const url = `${DEFAULT_DASHBOARD_URL}dashboardId=${props.dashboardId}&tabId=0`;
      window.open(url, "_self");
    } else if (!props.dashboardId) {
      easasAlert({ summary: T("alert.please-select-a-dashboard"), severity: "error" });
    }
  };

  return (
    <div>
      <Button label={props.title || T("action.redirect")} onClick={handleRedirect} />
    </div>
  );
}
